import { render, staticRenderFns } from "./CouponProducts.vue?vue&type=template&id=4c59e107&scoped=true"
import script from "./CouponProducts.vue?vue&type=script&lang=js"
export * from "./CouponProducts.vue?vue&type=script&lang=js"
import style0 from "./CouponProducts.vue?vue&type=style&index=0&id=4c59e107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c59e107",
  null
  
)

export default component.exports